import {Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, Input} from '@angular/core';
import {PopoverController} from "@ionic/angular";
import {ViewService} from "../../../services/common/view.service";
import {DataService} from "../../../services/common/data.service";
import {Poi} from "../../../classes/common/poi";

@Component({
  selector: 'app-popover-select-poi',
  templateUrl: './popover-select-poi.component.html',
  styleUrls: ['./popover-select-poi.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PopoverSelectPoiComponent implements OnInit {

  @Input() poi: [];

  searchQuery: string;


  /* pois = [
    {
      name: "el poi number 1",
      address: "Pl. relic 20, Bermuda (△)",
    },

    {
      name: `LUNNNNNNGO_PoiiiiLUNNNNNNGO_PoiiiiLUNNN
      NNNGO_PoiiiiLUNNNNNNGO_PoiiiiLU
      NNNNNNGO_PoiiiiLUNNNNNNGO_Poiiii`,
      address: "Viale della Seta 69, Zozze (TO), Italy",
    },

    {
      name: "el poi number 3",
      address: `cnwjdfnfrefregergergergregre
      gregregregregrgregeregergergergergergergregreg
      regergergergergergergergergergerge
      rgergergrw`,
    },

  ]; */


  // listener

  listener = {
    view: null,
  };

  constructor(
    private cd: ChangeDetectorRef,
    private popoverCtrl: PopoverController,
    public view: ViewService,
    public data: DataService
  ) {}



  ngOnInit() {
    // console.log("ngOnInit()");

    // passed args (bad animation when inside
    // ionViewDidEnter)
    /*//noinspection TypeScriptUnresolvedFunction
    let componentProps =
      this.navParams.get("componentProps");

    this.menu = componentProps.menu;
    // this.cd.markForCheck(); // needed?*/
  }


  ionViewWillEnter() {
  }


  ionViewDidEnter() {
    this.listenerView();
  }


  ionViewWillLeave() {
    if (this.listener.view) {
      this.listener.view.unsubscribe();
    }
  }

  ionViewDidLeave() {
  }


  ngOnDestroy() {
    // console.log("ngOnDestroy()");
  }





  /* async dismiss() {
    await this.popoverCtrl.dismiss();
  } */
  async dismiss(poi?: Poi) {
    await this.popoverCtrl.dismiss({poi: poi});
  }




  // listener

  listenerView() {
    this.listener.view = ViewService.updateView$.subscribe((obj?: any) => {
      // console.log("listener.view", obj);

      // this.zone.run(() => {

      this.view.pipeChanged++;
      this.cd.markForCheck();

      setTimeout(() => {
        this.cd.markForCheck();
      }, 250);

      // });
    });
  }







}
